module.exports = __webpack_public_path__ + "images/e0f059c0d79c1a1008e59877f48130f0.svg";